import { render, staticRenderFns } from "./KeywordSearch.vue?vue&type=template&id=2ec3223c&scoped=true&"
import script from "./KeywordSearch.vue?vue&type=script&lang=js&"
export * from "./KeywordSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec3223c",
  null
  
)

export default component.exports